import { Goal, ID, UpdateGoal } from '@griply/types';
import { shouldArchiveWithParent } from '@griply/utils';

export type BuildArchiveWithParentUpdateOptions = {
  parentGoalId?: ID | null;
  goal: Pick<Goal, 'archivedAt'>;
  allGoals: Goal[];
  now?: Date;
};

// Archived is inherited, so a goal moved under an archived parent is archived in the same write.
// Both apps spread this into their update so the rule cannot drift per platform.
export const buildArchiveWithParentUpdate = ({
  parentGoalId,
  goal,
  allGoals,
  now = new Date(),
}: BuildArchiveWithParentUpdateOptions): Pick<UpdateGoal, 'archivedAt'> =>
  shouldArchiveWithParent({
    parentGoalId,
    goalArchivedAt: goal.archivedAt,
    allGoals,
  })
    ? { archivedAt: now }
    : {};
